/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notes: [],
  count: 0,
};

const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    setNotesRedux(state, action) {
      state.notes = action.payload;
    },
    updateLeadNoteRedux(state, action) {
      const index = state.notes.findIndex(note => note.id === action.payload.id);
      if (index !== -1) {
        state.notes[index] = action.payload;
      }
    },
    addNote(state, action) {
      state.notes.unshift(action.payload);
      state.count++;
    },
    deleteNoteRedux(state, action) {
      const index = state.notes.findIndex(note => note.id === action.payload);
      if (index !== -1) {
        state.notes.splice(index, 1);
      }
    },
  },
});

export const { setNotesRedux, updateLeadNoteRedux, deleteNoteRedux, addNote } = notesSlice.actions;

export default notesSlice.reducer;
